module.exports = __webpack_public_path__ + "img/office.779324ec.jpg";